const blue: Record<string, string> = {
  50: '#f7f7f8',
  100: '#f4f5f5',
  200: '#e9ebec',
  300: '#dbdfe2',
  400: '#a3bcd2',
  500: '#609bd2',
  600: '#1976d2',
  700: '#0288d1',
  800: '#376d99',
  900: '#25567e',
  950: '#123654',
  DEFAULT: '#1976d2',
};

export default blue;
